function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var Ivisa = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "50",
    height: "32",
    viewBox: "0 0 50 32",
    notChangeable: true,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Visa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: "50",
    height: "32",
    rx: "3",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon9",
    d: "M22.4669 21.5355H19.3887L21.314 10.5H24.3921L22.4669 21.5355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M33.6256 10.7699C33.0184 10.5466 32.0554 10.3 30.8646 10.3C27.8247 10.3 25.684 11.8027 25.6709 13.951C25.6457 15.536 27.2036 16.4164 28.3688 16.9448C29.5597 17.4849 29.9645 17.8374 29.9645 18.3187C29.9524 19.058 29.0022 19.3988 28.1159 19.3988C26.8869 19.3988 26.2284 19.2231 25.2277 18.8118L24.8224 18.6355L24.3916 21.1127C25.1136 21.4176 26.4437 21.6882 27.8247 21.7C31.0546 21.7 33.1574 20.2207 33.1823 17.9313C33.1946 16.6751 32.372 15.7125 30.5985 14.9259C29.5218 14.421 28.8625 14.0805 28.8625 13.5639C28.8751 13.0942 29.4201 12.6131 30.6355 12.6131C31.6362 12.5896 32.3715 12.8125 32.9285 13.0357L33.2069 13.1529L33.6256 10.7699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M37.7167 17.626C37.9702 16.992 38.9457 14.5384 38.9457 14.5384C38.9329 14.5619 39.1987 13.8927 39.3507 13.4819L39.5658 14.4327C39.5658 14.4327 40.1487 17.0743 40.2753 17.626C39.7942 17.626 38.3247 17.626 37.7167 17.626ZM41.5164 10.5H39.1354C38.4011 10.5 37.8433 10.6994 37.5265 11.4156L32.9541 21.5353H36.184C36.184 21.5353 36.7158 20.1733 36.8301 19.88C37.1844 19.88 40.3265 19.88 40.7823 19.88C40.8707 20.2674 41.1496 21.5353 41.1496 21.5353H43.9998L41.5164 10.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M16.8168 10.5L13.8021 18.0252L13.4727 16.499C12.9154 14.7379 11.1674 12.8246 9.2168 11.8733L11.9781 21.5238H15.2333L20.0718 10.5H16.8168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M11.0033 10.5H6.05067L6 10.723C9.86336 11.6388 12.422 13.8462 13.4732 16.4994L12.3966 11.4276C12.2193 10.7228 11.6746 10.5232 11.0033 10.5Z",
    fill: "#FAA61A"
  })))));
});